import { List, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SlackChannelDeepLink } from 'components/SlackChannelDeepLink';

type SlackChannelListItem = {
  label: string;
  channelName?: string | null;
  channelId?: string | null;
};

type SlackChannelListProps = {
  channels: SlackChannelListItem[];
};

export const SlackChannelList = (props: SlackChannelListProps): JSX.Element => {
  const { channels } = props;
  const { t } = useTranslation();

  // A channel is only linkable when it has both a name and an id.
  const linkableChannels = channels.filter(
    (channel) => channel.channelName && channel.channelId,
  );

  if (linkableChannels.length === 0) {
    return (
      <Typography color="textSecondary" sx={{ p: 2 }}>
        {t('slackChannels.unavailable')}
      </Typography>
    );
  }

  return (
    <List disablePadding>
      {linkableChannels.map((channel) => (
        <SlackChannelDeepLink
          key={`${channel.label}-${channel.channelName}`}
          label={channel.label}
          channelId={channel.channelId}
          channelName={channel.channelName ?? undefined}
        />
      ))}
    </List>
  );
};
